import customImageProps from './types';

const customImage: React.FC<customImageProps> = ({
  src,
  alt,
  width = '100%',
  height,
}) => {
  return <img src={src} alt={alt} width={width} height={height} />;
};

export default customImage;
